import React from 'react';
import PropTypes from 'prop-types';

// properties on EntryActivitiesView
// showAllMetrics
// title
// metrics
// mapview

// example of output:
// Ben ran 4 mi
// felt alright, 530 cal

// const statClassesForActivityType = (activityType) => {
//   const statClasses = [];
  
//   if(activityType.hasSets) {
//     statClasses.push(DMSActivityStatSets.class);
//   }
//   if(activityType.hasReps) {
//     statClasses.push(DMSActivityStatReps.class);
//   }
//   if(activityType.hasWeight) {
//     statClasses.push(DMSActivityStatWeight.class);
//   }
//   if(activityType.hasDistance) {
//     if(activityType.hasDistance) {
//       if(activityType.name === "Swimming") {
//         statClasses.push(DMSActivityStatDistanceSwimming.class);
//       } else {
//         statClasses.push(DMSActivityStatDistance.class);
//       }
//     }
//   }
//   if(activityType.hasDistance && activityType.hasDuration) {
//     statClasses.push(DMSActivityStatPace.class);
//   }
//   statClasses.push(DMSActivityStatCalories.class); // every activity type should have calories
//   if(activityType.hasDuration) {
//     statClasses.push(DMSActivityStatDuration.class);
//   }
//   if(activityType.dms_category == DMSActivityTypeCategoryCardio) { // HACK:
//     statClasses.push(DMSActivityStatElevationGain.class);
//   }
  
//   return statClasses;
// }

// const firstStatClassForActivity = (activity) => {
//     let titleStatClass;
    
//     // return the first stat class that has a value for the given activity
//     for(var statClass in statClassesForActivityType(activity.activityType)) {
//       DMSActivityStat *stat = new stateClass();
//       [stat setValueWithActivity:activity];
//       if(stat.hasValue) {
//         titleStatClass = statClass;
//         break;
//       }
//     }

//     return titleStatClass;
// };

const EntryActivities = (props) => {
  // let titleStatClass;
  // if (!props.entryTitle && props.entry.activities.length === 1) {
  //   // if there's no title and only a single activity, then let's put a stat in the title
  //   titleStatClass = firstStatClassForActivity(props.entry.activities[0]);
  // }
  // const title = [self _buildTitle:entry titleStatClass:titleStatClass];
  // const description = [self _buildDescription:entry titleStatClass:titleStatClass showAllStats:showAllStats];

  const entryTitle = props.entry.title;
  const activityTypeName = props.entry.activities[0].activityType.name;
  
  const metrics = props.entry.activities.length === 1 ? '1 activity' : '2 activities';

  return (
    <div>
      <strong><a>{props.entry.user.displayName}</a> did {entryTitle ? entryTitle : activityTypeName}</strong>
      <span>{metrics}</span>
    </div>
  );
}

EntryActivities.propTypes = {
  entry: PropTypes.object.isRequired
};

export default EntryActivities;


// WEBPACK FOOTER //
// ./src/views/entryActivities.js